import React, { useEffect, useState } from 'react'
import { SearchFunction } from "../components/search-function/search-function"
import { useGetUser } from "./useGetUser"
import spinner from "../assets/img/loading-green.svg"


//Haversine formula for distance
const calcDistance = (lat1, lon1, lat2, lon2 ) => {
  let p = 0.017453292519943295;    // Math.PI / 180
  let c = Math.cos;
  let a = 0.5 - c((lat2 - lat1) * p)/2 +
      c(lat1 * p) * c(lat2 * p) *
      (1 - c((lon2 - lon1) * p))/2;

  return Math.ceil(7918 * Math.asin(Math.sqrt(a))); // 2 * R; R = miles
}

export const ContractorManager = () => {

  const apiURL = "/wp-json/fac/v1/get-contractors";

  const [loadState, setLoadState ] = useState( true );
  const [contractors, setContractors] = useState( [] );
  const [fullContractorList , setFullContractorList] = useState( [] );

  const [ location, setLocation] = useState(null);
  const [ filters, setFilters ] = useState([{type: 'membership', args: ['platinum', 'gold', 'silver']}])


  //append new items to or replace filters in filters state
  const updateFilters = (paramFilters) => {
    let updatedFilters = paramFilters;

    if (filters.length > 0) {
      updatedFilters = [
          ...paramFilters, 
          ...filters.map(filter => {
          let filterAlreadyExists = paramFilters.some(function(paramFilter) { return filter.type === paramFilter.type })

          //update the args for the filter to make use of those in paramFilters
          if (filterAlreadyExists) {
            let matchingParamFilter = paramFilters.filter(paramFilter => {
              return filter.type === paramFilter.type
            })
            filter['args'] = matchingParamFilter[0].args
          }

          return filter
        })
      ]
 
      // remove filter dups
      return [...new Map(updatedFilters.map(v => [v.id, v])).values()]
    }

    return updatedFilters
  }

  const user = useGetUser(location, setFilters, updateFilters);

  const handleLocation = (location) => {
    setLocation(location);
  }

  // Calculate distances for each of the contractors
  const getDistances = (user, contractors) => {
    return contractors.map((contractor) => {
      return {...contractor,
              distance: calcDistance(user.lat, user.long,
                                      contractor.address1_latitude,
                                      contractor.address1_longitude )}
    })
  }

  useEffect(() => {
    fetch( apiURL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json'
          }
        })
      .then(res => res.json())
      .catch(console.error)
      .then((data) => {
        setContractors( data );
        setFullContractorList ( data );
      })
      .then(() => {
        setLoadState( false );
      })

    }, [setLoadState]);

  // When we get a user location calculate the distances between the user and
  // each contractor.
  useEffect(() => {
    if (user) {
      setContractors((currentContractors) => getDistances(user, currentContractors));
    } else {
      setContractors(fullContractorList);
    }
  }, [user]);


  // TODO Add a "loading state" component
  if (loadState) {
    return (
      <img src={spinner} alt="loading" className='fac-loading-spinner' />
    )
  }
  return (
      <SearchFunction contractors={contractors} fullContractorList={fullContractorList} handleLocation={handleLocation} user={user} filters={filters} setFilters={setFilters} />
  )
}
